import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Checkbox from '@service-victoria/component-library/components/Checkbox';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import * as Styled from '../styled';
import { constants } from 'utils';

export type ComponentProps = StepComponent<
  Pick<Interfaces.Common.FormValues, 'prerequisiteChecks'>
>;

const Select: React.FC<ComponentProps> = () => (
  <Styled.Wrapper>
    <Text.Heading.H1 fontWeight={600}>Before you apply</Text.Heading.H1>
    <Text.Body>
      Make sure you&apos;ve read the{' '}
      <Text.Link href={constants.externalLinks.guidelines} value='guidelines' target='_blank' />,
      then check all boxes that apply below. I confirm that:
    </Text.Body>
    <Styled.Spacer16 />
    <Checkbox
      name='prerequisiteChecks.applicantOver18'
      label='I am a Victorian resident aged 18 years or older'
    />
    <Checkbox
      name='prerequisiteChecks.withinGuidelines'
      label='I am travelling to one of the 26 local government areas in metropolitan Melbourne as stated in the guidelines'
    />
    <Checkbox
      name='prerequisiteChecks.sufficientTime'
      label={`I am intending to spend two or more consecutive nights in metropolitan Melbourne between ${constants.contentDates.travelPeriodStart} and ${constants.contentDates.travelPeriodEnd} 2021`}
    />
    <Checkbox
      name='prerequisiteChecks.sufficientSpending'
      label='I am going to spend at least $400 on eligible paid accommodation plus tours, experiences and attractions'
    />
    <Checkbox
      name='prerequisiteChecks.CanClaimInTime'
      label={`I am prepared to provide copies of invoices as evidence of my spending and submit them before ${constants.contentDates.claimDealine}`}
    />
    <Checkbox
      name='prerequisiteChecks.noPriorTravel'
      label='Neither I nor anybody else in my household has already claimed a Melbourne travel voucher under this scheme'
    />
  </Styled.Wrapper>
);

export default Select;
